// RouteChangeCanceler.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AxiosRequestManager } from '../../utils/AxiosRequestManager';

const RouteChangeCanceler = () => {
  const location = useLocation();

  useEffect(() => {
    AxiosRequestManager.cancelAll();
  }, [location]);

  return null;
};

export default RouteChangeCanceler;